import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [RouterModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent {
  readonly linkedinUrl = 'https://www.linkedin.com/company/revecloud';
  readonly instagramUrl = 'https://www.instagram.com/reve.cloud/';

  constructor(private router: Router) { }

  navigateTo(route: string): void {
    if (this.router.url === route) {
      this.scrollToTop();
      return;
    }

    this.router.navigate([route]);
    this.scrollToTop();
  }

  onNavigationLinkClick(route: string): void {
    if (this.router.url === route) {
      this.scrollToTop();
    }
  }

  private scrollToTop(): void {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

}